import {
    Directive,
    HostListener
} from '@angular/core';
import { NgModel } from '@angular/forms';
import { CacheConstant } from '../../core/constants/app.constant';
import { AppCacheService } from '../../core/services/cache/app-cache.service';

@Directive({
    selector: '[ngModel][poValue]'
})

export class poValidationDirective {
    private value: any;
    private parmedPoRegex = /^[^`~*@|\\'"<>]*$/;
    private majorPoRegex = /^[^`|\\]*$/;
    private inputPoValue = [];
    websiteName = this.cache.get(CacheConstant.Env_Properties).theme;
    poValidation: any;

    constructor(public model: NgModel, private cache: AppCacheService,) { }

    @HostListener('input', ['$event'])
    onInputChange(event) {
        this.poValidation = this.websiteName == 'Parmed' ? this.parmedPoRegex : this.majorPoRegex;
        this.value = event.target.value
        this.inputPoValue = event.target.value.split('');
        this.inputPoValue.forEach(element => {
            if (!this.poValidation.test(element)) {
                this.value = this.value.replace(element, '');
            }
        });
        this.model.valueAccessor.writeValue(this.value);
        this.model.viewToModelUpdate(this.value);
    }
}
